import { useMemo } from 'react'

import { CustomEditor } from 'core-components/library/richTextEditor/interface/custom-types'

import { canInsertColLeft, canInsertColRight } from '../helpers/insertColumnsHelper'
import { canInsertRowAbowe, canInsertRowBelow } from '../helpers/insertRowsHelper'
import { canMerge } from '../helpers/mergeCellsHelper'
import { canSplit } from '../helpers/splitCellsHelper'
import { TableColumnActions, TableRowActions } from '../models/tableActions'

import { TableCellsActions } from './../models/tableActions'

export const useButtonAccess = (editor: CustomEditor) => {
  return useMemo(() => {
    const enabledButtons: (TableCellsActions | TableColumnActions | TableRowActions)[] = [
      TableCellsActions.SPLIT_CELL_COLUMN,
    ]
    const { canInsertableRight } = canInsertColRight(editor)
    const { canInsertableLeft } = canInsertColLeft(editor)
    const { canInsertableAbowe } = canInsertRowAbowe(editor)
    const { canInsertableBelow } = canInsertRowBelow(editor)
    const { canSplitToRow } = canSplit(editor)
    const { canMergeCells } = canMerge(editor)
    if (canInsertableRight) {
      enabledButtons.push(TableColumnActions.INSERT_RIGHT)
    }
    if (canInsertableLeft) {
      enabledButtons.push(TableColumnActions.INSERT_LEFT)
    }
    if (canInsertableAbowe) {
      enabledButtons.push(TableRowActions.INSERT_ROW_ABOVE)
    }
    if (canInsertableBelow) {
      enabledButtons.push(TableRowActions.INSERT_ROW_BELOW)
    }
    if (canSplitToRow) {
      enabledButtons.push(TableCellsActions.SPLIT_CELL_ROW)
    }
    if (canMergeCells) {
      enabledButtons.push(TableCellsActions.MERGE_CELLS)
    }

    return {
      enabledButtons,
    }
  }, [editor.selection])
}
